import Entity from "./Entity";

export default class Publisher extends Entity {
    constructor(data) {
        super(data);
    }

    get id() {
        return this.get("id");
    }

    getId() {
        return this.get("id");
    }

    getName() {
        return this.get("name");
    }

    getGeneralStatistics() {
        return this.get("generalStatistics");
    }
}